import { Box, Text } from '@factorialco/deprecated-design-system'
import { BalanceTag } from '@factorialco/factorial-one-react/dist/experimental'
import { BankingBankAccountOverviewFragment } from 'generated/resources/graphql'

import { bankAccountLastDigits, bankLogo } from 'modules/banking/utils'

interface BalancePercentageTagProps {
  bankAccount: BankingBankAccountOverviewFragment
  amountFormatter: (value: number, currency: string) => string
}

const calculateBalancePercentageChange = (currentBalance: number, previousBalance: number) => {
  return ((currentBalance - previousBalance) * 100) / Math.abs(previousBalance)
}

const BalancePercentageTag = ({
  percentChange,
  amountFormatted,
}: {
  percentChange: number
  amountFormatted: string
}) => {
  return (
    <BalanceTag
      status={percentChange < 0 ? 'negative' : 'positive'}
      text={
        (percentChange === Infinity || isNaN(percentChange)
          ? ''
          : percentChange.toFixed(2) + '% · ') + amountFormatted
      }
    />
  )
}

export const BankAccountItem = ({ bankAccount, amountFormatter }: BalancePercentageTagProps) => {
  const { account } = bankAccount
  return (
    <Box flexDirection="row" alignItems="center" justifyContent="spaceBetween">
      <Box flexDirection="row" gap="s8" alignItems="center">
        {bankLogo(account, bankAccount.accountAlias || account.institution?.name || '')}
        <Box>
          <Text.Normal size="200" weight="medium">
            {bankAccount.accountAlias || account.institution?.name || ''}
          </Text.Normal>
          <Text.Normal size="200" weight="medium">
            {bankAccountLastDigits(bankAccount)}
          </Text.Normal>
        </Box>
      </Box>
      <Box gap="s2" alignItems="flexEnd" textAlign="right">
        <Text.Normal
          size="200"
          weight="medium"
          color={bankAccount.accountBalanceCents < 0 ? 'radicalRed1200' : 'grey800'}
        >
          {amountFormatter(bankAccount.accountBalanceCents, bankAccount.currency.toUpperCase())}
        </Text.Normal>

        <BalancePercentageTag
          percentChange={calculateBalancePercentageChange(
            bankAccount.accountBalanceCents,
            bankAccount.transactionsConnection.nodes[0]?.balanceAfterCents || 0
          )}
          amountFormatted={amountFormatter(
            bankAccount.accountBalanceCents -
              (bankAccount.transactionsConnection.nodes[0]?.balanceAfterCents || 0),
            bankAccount.currency.toUpperCase()
          )}
        />
      </Box>
    </Box>
  )
}
